<script setup>
import { ref, watch, toRaw } from "vue"
import { storeToRefs } from "pinia"
import Loader from "./Loader.vue"
import { useFilteredFeedStore } from "../stores/FilteredFeed.js"

defineProps({
	title: {
		type: String,
		required: false,
		default: "Search with keywords",
	},
	placeholder: {
		type: String,
		required: false,
		default: "Search with keywords",
	},
	submitLabel: {
		type: String,
		required: false,
		default: "Submit",
	},
})

const toggled = ref(false)
const searchTerm = defineModel()

const store = useFilteredFeedStore()
const { filters } = storeToRefs(store)

watch(filters, () => {
	const watchFilters = toRaw(filters.value)
	if (!Object.keys(watchFilters).length) {
		searchTerm.value = null
	}
})

function updateSearch() {
	store.updateFilters({
		taxonomy: "keyword",
		term: searchTerm.value || null,
	})
}
</script>
<template>
	<div class="flex flex-col md:flex-row gap-8 md:items-center">
		<span class="capsule border-2 border-white p-0 aspect-square justify-center hidden md:flex">
			<svg xmlns="http://www.w3.org/2000/svg" class="size-8" viewBox="0 0 33.055 33.055">
				<g id="Group_251" data-name="Group 251" transform="translate(4.914 2.908)">
					<g id="Group_243" data-name="Group 243" transform="translate(-2.914 -0.908)">
						<circle
							id="Ellipse_49"
							data-name="Ellipse 49"
							cx="11.856"
							cy="11.856"
							r="11.856"
							transform="translate(0 0)"
							fill="none"
							stroke="#1e113f"
							stroke-miterlimit="10"
							stroke-width="4"
						/>
						<line
							id="Line_151"
							data-name="Line 151"
							x2="9.881"
							y2="9.881"
							transform="translate(19.76 19.76)"
							fill="none"
							stroke="#1e113f"
							stroke-miterlimit="10"
							stroke-width="4"
						/>
					</g>
				</g>
			</svg>
		</span>
		<p class="text-md md:text-lg font-mono">{{ title }}</p>
		<input type="text" v-model="searchTerm" class="capsule bg-white flex-grow normal-case focus:ring-2 ring-blue outline-none" spellcheck="off" :placeholder="placeholder" @keydown.enter="updateSearch()" />
		<button class="submit-button min-w-36 justify-end -ml-6" @click.prevent="updateSearch()" :disabled="store.isLoading">
			<span>{{ store.isLoading ? "Loading" : submitLabel }}</span>
			<svg
				v-if="!store.isLoading"
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				stroke-width="1.5"
				stroke="currentColor"
				class="size-6"
			>
				<path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
			</svg>
			<Loader v-if="store.isLoading" class="size-6" />
		</button>
	</div>
</template>
